import styled from 'styled-components'

export const DegreeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
